<template>
  <div>
    <div class="fl m-b-20">
      <span>时间范围：</span>
      <el-date-picker
        v-model="currentTime"
        type="daterange"
        align="left"
        placeholder="选择日期范围"
        :picker-options="pickerOptions"
        @change="timeChange">
      </el-date-picker>
    </div>
    <el-table :data="leaveStatistics">
      <el-table-column label="姓名" prop="name"></el-table-column>
      <el-table-column label="事假">
        <template scope="scope">{{scope.row.statistics_list[0]}}</template>
      </el-table-column>
      <el-table-column label="病假">
        <template scope="scope">{{scope.row.statistics_list[1]}}</template>
      </el-table-column>
      <el-table-column label="婚假">
        <template scope="scope">{{scope.row.statistics_list[2]}}</template>
      </el-table-column>
      <el-table-column label="产假">
        <template scope="scope">{{scope.row.statistics_list[3]}}</template>
      </el-table-column>
      <el-table-column label="丧假">
        <template scope="scope">{{scope.row.statistics_list[4]}}</template>
      </el-table-column>
      <el-table-column label="年假">
        <template scope="scope">{{scope.row.statistics_list[5]}}</template>
      </el-table-column>
      <el-table-column label="外勤">
        <template scope="scope">{{scope.row.statistics_list[6]}}</template>
      </el-table-column>
      <el-table-column label="其他">
        <template scope="scope">{{scope.row.statistics_list[7]}}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template scope="scope">
          <el-button type="primary" size="small" @click="lookInfo(scope.row.name)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="fr">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :page-size="form.limit"
            :current-page="form.page"
            :total="leaveStatistics.length">
        </el-pagination>
      </div>
      <leave-dialog
        :name="currentName"
        :startTime="form.time_start"
        :endTime="form.time_end"
        ref="leaveDialog">
      </leave-dialog>
  </div>
</template>
<script>
import http from 'assets/js/http'
import leaveDialog from './leaveInfoDialog'
export default {
  iden: 'leaveStatistics',
  data() {
    return {
      leaveStatistics: [],
      form: {
        time_start: '',
        time_end: '',
        page: 1,
        limit: 10
      },
      currentTime: '',
      currentName: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '本月',
          onClick(picker) {
            const year = new Date().getFullYear()
            const month = new Date().getMonth() + 1
            const end = new Date()
            const start = new Date()
            // 获取月份总天数
            const lastDay = new Date(year, month, 0).getDate()
            const startDate = _g.parseToTimeStamp(new Date(`${year}-${month}-1`))
            const lastDate = _g.parseToTimeStamp(new Date(`${year}-${month}-${lastDay}`))
            start.setTime(startDate)
            end.setTime(lastDate)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '上月',
          onClick(picker) {
            const year = new Date().getFullYear()
            const month = new Date().getMonth()
            const end = new Date()
            const start = new Date()
            // 获取月份总天数
            const lastDay = new Date(year, month, 0).getDate()
            const startDate = _g.parseToTimeStamp(new Date(`${year}-${month}-1`))
            const lastDate = _g.parseToTimeStamp(new Date(`${year}-${month}-${lastDay}`))
            start.setTime(startDate)
            end.setTime(lastDate)
            picker.$emit('pick', [start, end])
          }
        },{
          text: '今年',
          onClick(picker) {
            const year = new Date().getFullYear()
            const month = new Date().getMonth()
            const end = new Date()
            const start = new Date()
            // 获取月份总天数
            const lastDay = new Date(year, 12, 0).getDate()
            const startDate = _g.parseToTimeStamp(new Date(`${year}-1-1`))
            const lastDate = _g.parseToTimeStamp(new Date(`${year}-12-${lastDay}`))
            start.setTime(startDate)
            end.setTime(lastDate)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  created() {
    this.getLeaveStatistics()
  },
  methods: {
    timeChange(val) {
      this.form.page = 1
      if (!val) {
        this.form.time_start = ''
        this.form.time_end = ''
      } else {
        this.form.time_start = this.currentTime[0].getTime() / 1000
        this.form.time_end = this.currentTime[1].getTime() / 1000
      }
      this.getLeaveStatistics()
    },
    lookInfo(name) {
      this.currentName = name
      setTimeout(() => {
        this.$refs.leaveDialog.openDialog()
      }, 200)
    },
    handleSizeChange() {},
    handleCurrentChange() {},
    getCurrentMonth() { // 本月时间获取
      // 当前月份
      const end = new Date()
      const start = new Date()
      const month = start.getMonth() + 1
    },
    getLeaveStatistics() {
      let input = {
        params: this.form
      }
      this.apiGet('custom/leave/statistics', input).then((res) => {
        if (res.code === 200) {
          this.leaveStatistics = res.data.list
        }
      })
    }
  },
  components: {
    leaveDialog
  },
  mixins: [http]
}
</script>




// WEBPACK FOOTER //
// leaveStatistics.vue?139d886e